
const DEBUG =0;
 var debug_url = 'http://www.maoshu.com/';
//var debug_url = 'http://novel.kiseng.vip/';
var debug_url = 'http://www.qxxe.cn/';
 //var debug_url = 'http://n11.yaoyaozw.com/';
//var debug_url = 'http://a4.yaoyaozw.com/';
let ulr = window.location.host;
 var deman_url  = 'http://' + ulr + '/';
export default {
            server_url:DEBUG?debug_url:deman_url,
            DEBUG:DEBUG
}